<div class="dropdown-container">
  <!-- Dropdown Toggle -->
  <div class="dropdown-toggle" (click)="toggleDropdown()">
    <img class="selection-image" [src]="getSelectedBgIcon()" width="30" height="30" alt="Selected Icon" />
    <mat-label class="sceneTypeLabel">
      <span class="hide-lt-md">{{ 'general.editorBackground' | transloco }}</span>
    </mat-label>

  </div>

  <!-- Dropdown Menu -->
  @if (dropdownOpen) {
    <div class="dropdown-menu">
      <div fxFlex="column" fxLayoutAlign="center center" style="width: 160px">
        <img
          ngSrc="assets/images/black.png"
          width="30"
          height="30"
          priority
          (click)="onActiveBgSelection('0')"
          [ngClass]="{'activeBgSelection': bgSelection == '0', invertedStyle: theme == '1'}"
          class="bgSelection"
          />
          <img
            ngSrc="assets/images/dots.png"
            width="30"
            height="30"
            priority
            (click)="onActiveBgSelection('1')"
            [ngClass]="{'activeBgSelection': bgSelection == '1', invertedStyle: theme == '1'}"
            class="bgSelection"
            />
            <img
              ngSrc="assets/images/checkers.png"
              width="30"
              height="30"
              priority
              (click)="onActiveBgSelection('2')"
              [ngClass]="{'activeBgSelection': bgSelection == '2', invertedStyle: theme == '1'}"
              class="bgSelection"
              />
              <img
                ngSrc="assets/images/rows.png"
                width="30"
                height="30"
                priority
                (click)="onActiveBgSelection('3')"
                [ngClass]="{'activeBgSelection': bgSelection == '3', invertedStyle: theme == '1'}"
                class="bgSelection"
                />
              </div>
            </div>
          }
        </div>
